module.exports = __webpack_public_path__ + "static/media/lancome-tresor-big.76b27a09.png";